import { addDocument } from "../WebMethods/AddDocument";
import { getCollection } from "../WebMethods/ReadCollection";

const fetchCsv = async () => {
    try {
      // const response = await fetch("./sourceData.csv"); // Ensure correct path
      // const csvText = await response.text();
      // const parsedData = parseCsv(csvText);
      // for (const d of parsedData) {
      //   await addDocument("questions", d);
      // }
      // return parsedData;
      const firebaseData = await getCollection("questions"); 
      // console.log(firebaseData);
      return firebaseData;
    } catch (error) {
      console.error("Error fetching CSV:", error);
    }
  };

  const parseCsv = (csvText) => {
    const rows = csvText.trim().split("\n"); // Split by lines
    const headers = rows[0].split(";"); // Extract headers
    const data = rows.slice(1).map((row) => {
      const values = row.split(";"); // Split values
      return headers.reduce((acc, header, index) => {
        acc[header.trim()] = values[index]?.trim(); // Map headers to values
        return acc;
      }, {});
    });

    return data;
  };
  export default fetchCsv;